import {style} from 'typestyle'
import * as csstips from 'csstips'

export const WkNewTag = style({
    width: 24,
    height: 15,
    display: 'inline-block',
    overflow: 'hidden',
    position: 'relative',
    marginRight: 5,
    top: 2
})

export const TagContent = style({
    'fontSize': 18,
    'width': 48,
    'height': 30,
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.centerJustified,
    'color': 'rgb(102, 102, 102)',
    'border': '1px solid rgb(102, 102, 102)',
    'transform': 'scale(0.5, 0.5)',
    'transformOrigin': '0 0',
    'borderRadius': 8,
    '-webkit-transform-origin': '0 0',
    '-webkit-transform': 'scale(0.5, 0.5)'
})



// WEBPACK FOOTER //
// ./src/views/Category/components/CategoryRecommendLectureItemList/HomeItemTag.style.ts